import {REGISTER_USER, REGISTER_USER_ERROR, REGISTER_USER_SUCCESS} from "./actionTypes";

const initialState = {
    error: null,
    loading: false
};

const register = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_USER:
            state = {
                ...state,
                loading: true
            };
            break;
        case REGISTER_USER_SUCCESS:
            state = {
                ...state,
                error: null,
                loading: false
            };
            break;
        case REGISTER_USER_ERROR:
            state = {
                ...state,
                error: action.payload,
                loading: false
            };
            break;
        default:
            state = {...state};
            break;
    }
    return state;
};

export default register;